<template>
  <div
    class="my-8 p-8 bg-white rounded text-gray-800"
    v-if="fund.details.name !== undefined"
  >
    <!-- Page 1 -->
    <div style="break-after: page;">
      <p class="font-bold text-center text-lg">{{ fund.details.name}}</p>
      <table class="mt-8 table-auto w-full">
        <tbody>
          <tr>
            <td class="px-4 py-2 font-bold">Property:</td>
            <td class="px-4 py-2">{{ fullAddress }}</td>
          </tr>
          <tr>
            <td class="px-4 py-2 font-bold">Tenant:</td>
            <td class="px-4 py-2">{{ tenantName }}</td>
          </tr>
          <tr>
            <td class="px-4 py-2 font-bold" colspan="2">Tenant's circumstances:</td>
          </tr>
          <tr>
            <td class="px-4 py-2 pl-8 font-bold">Eligible for JobKeeper:</td>
            <td class="px-4 py-2">Yes</td>
          </tr>
          <tr>
            <td class="px-4 py-2 pl-8 font-bold">Turnover of less than $50m:</td>
            <td class="px-4 py-2">Yes</td>
          </tr>
          <tr>
            <td class="px-4 py-2 pl-8 font-bold">Estimated Reduction in Turnover:</td>
            <td class="px-4 py-2">{{turnOverPercentage}}%</td>
          </tr>
          <tr>
            <td class="px-4 py-2 pl-8 font-bold">Impacted by Covid-19:</td>
            <td class="px-4 py-2">
              <!-- eslint-disable-next-line max-len -->
              <span class="-ml-2 px-2 py-2 bg-yellow-300 font-bold rounded text-yellow-700">No</span>
            </td>
          </tr>
        </tbody>
      </table>
      <!-- eslint-disable max-len -->
      <div class="mt-4">
        <p>Unfortunately the Covid-19 Rent Relief documentation package is not appropriate for this case.</p>
        <p class="mt-2">In order to be eligible for rent relief under the temporary arrangements in place for Covid-19, the tenant must have been adversely financially affected by Covid-19.  This could be indirect (for example, a major impact on key clients which in turn translates to a material loss of revenue for the tenant’s business) but it must be possible to link the current downturn in the tenant’s circumstances to the pandemic.</p>
        <p class="mt-2">Since that does not apply in this case, this tool cannot be used to prepare appropriate documentation for any rent relief provided.</p>
        <p class="mt-2">Note that rent relief may still be appropriate.  An SMSF landlord can always consider adjusting the terms of a tenant’s lease in a way that is favourable to the tenant if there are sound commercial reasons to do so.  If, for example:</p>
        <ul class="ml-5 list-outside list-disc">
          <li>the tenant experiences financial difficulties and is unable to meet rental payments but the landlord considers finding a new tenant will be difficult or take a long time,</li>
          <li>the tenant’s issues are temporary and a realistic plan to return to normal has been put in place, or</li>
          <li>the tenant’s presence has a material (positive) impact on other businesses within the property (for example, a key tenant in a shopping complex that attracts other tenants).</li>
        </ul>
        <p class="mt-2">In cases like these, the SMSF trustee may be able to argue that temporarily waiving or deferring rent is a financially responsible approach.</p>
        <p class="mt-2">However, the documentation to do this will be different and should be prepared using a different form.  Different supporting evidence will also be required.</p>
      </div>
      <!-- eslint-enable max-len -->
    </div>
  </div>
</template>

<script>
export default {
  name: 'rent-relief-ineligible',
  computed: {
    fund() {
      return this.$store.getters['fund/getFund'];
    },
    rentRelief() {
      return this.$store.getters['toolkit/getItemData'];
    },
    property() {
      return this.rentRelief.property;
    },
    fullAddress() {
      return `${this.property.address.street} ${this.property.address.suburb} ${this.property.address.state} ${this.property.address.postCode}`;
    },
    tenantName() {
      if (this.property.tenant.type === 'Trust') {
        return `${this.property.tenant.details.trusteeName} as trustee for ${this.property.tenant.details.trustName}`;
      }
      return this.property.tenant.details.companyName;
    },
    turnOverPercentage() {
      return this.rentRelief.determination.turnoverReduction;
    },
  },
};
</script>

<style>

</style>
